import React from 'react'

export default class IconEllipsis extends React.Component {
    render() {
        let className = 'icons-icon'
        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M8.00005 9.19999C7.33731 9.19999 6.80005 8.66273 6.80005 7.99999C6.80005 7.33725 7.33731 6.79999 8.00005 6.79999C8.66279 6.79999 9.20005 7.33725 9.20005 7.99999C9.20005 8.66273 8.66279 9.19999 8.00005 9.19999Z'
                    fill='currentColor'
                />
                <path
                    d='M4.00005 9.19999C3.33731 9.19999 2.80005 8.66273 2.80005 7.99999C2.80005 7.33725 3.33731 6.79999 4.00005 6.79999C4.66279 6.79999 5.20005 7.33725 5.20005 7.99999C5.20005 8.66273 4.66279 9.19999 4.00005 9.19999Z'
                    fill='currentColor'
                />
                <path
                    d='M12 9.19999C11.3373 9.19999 10.8 8.66273 10.8 7.99999C10.8 7.33725 11.3373 6.79999 12 6.79999C12.6628 6.79999 13.2 7.33725 13.2 7.99999C13.2 8.66273 12.6628 9.19999 12 9.19999Z'
                    fill='currentColor'
                />
            </svg>
        )
    }
}
